import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable({
  providedIn: "root",
})
export class ExcelServicesService {
  constructor() {}
  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    isNameGenerated?: boolean
  ): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName, isNameGenerated);
  }
  private saveAsExcelFile(
    buffer: any,
    fileName: string,
    isNameGenerated?: boolean
  ): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileName = isNameGenerated
      ? fileName
      : fileName + "_export_" + new Date().getTime();
    saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
